module.exports = __webpack_public_path__ + "img/borchia_6.552246c3.svg";